import { Component, OnInit,ViewChild,ViewContainerRef } from '@angular/core';
import { DataService } from '../../shared/services/dataService';
import { HttpClient } from '@angular/common/http';
import { Router } from "@angular/router";
import { AuthService } from '../../shared/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgTableColumn } from 'src/app/components/forms/ng-table.inferface';
import { Observable } from 'rxjs';
import { NgTableComponent } from 'src/app/components/forms/ng-table.component';


@Component({
  selector: 'app-main-menu-component',
    templateUrl: './main-menu.component.html'
})

export class MainMenuComponent  implements OnInit{
  @ViewChild(NgTableComponent) table: NgTableComponent;
  
  request: DataService;
  permission: any = {};
    constructor(
      private toastr: ToastrService,
      private http: HttpClient,
      private router: Router,
      private service: DataService,
      private authService: AuthService
    ) {
        
   }
 

  async ngOnInit(): Promise<void> {
 
    this.permission =   this.authService.getPermission(this.router.url);
  }
 
  public datasource: any = (params: DataService): Observable<any> => {    
    return this.service.post('menu/listmainmenu', params);
  }  
 
  getPermissionByRole(submenucode: any) {
    this.service.post("roles/getpermission", submenucode)
      .subscribe((response: any) => {
        this.permission = response;
        console.log(this.permission);
      },
        error => {
          this.toastr.error(error.message, 'Error!');
        });
  }
  onEdit(e) {
    this.router.navigate(['/admin/mainmenu/editing/'+e.id]);
  }
  onDelete(row: any) {
    if (confirm("Are you sure delete this record?")) {
      this.service.delete("menu/deletemainmenu", row.id)
        .subscribe(response => {
          this.toastr.success("Delete completed.", 'Success.');
          this.table.refresh();
        },
        error => {
          this.toastr.error(error.message, 'Error!');
        });
    }
  }

  public columns: Array<NgTableColumn> = [  
    {title: 'รหัส', name: 'code',sort: true,},
    {title: 'ชื่อเมนูหลัก', name: 'name', sort: true},
    {title: 'รายละเอียด', name: 'description', sort: true},
    {title: 'ลำดับ', name: 'seq', sort: true, },
    {title: 'Action', template: 'action',width: '10%',sort: false,},
  ];
}
